import { get } from 'lodash-es';
import { journeyAPI, orderAPI } from '@/api/careClient';
import { COMMON_ROUTES } from '@/config/route';
import { PARAM_VERIFY_ERROR_TYPE_CARE_ORDER_BABY_FORM_ERROR_TYPE_MAP, } from '../../config/error';
const getCareOrderBabyFormErrorTypes = ({ badParamsErrorTypes, }) => {
    const careOrderBabyFormErrorTypes = badParamsErrorTypes.map((badParamsErrorType) => {
        const careOrderFormErrorType = PARAM_VERIFY_ERROR_TYPE_CARE_ORDER_BABY_FORM_ERROR_TYPE_MAP[badParamsErrorType];
        return careOrderFormErrorType;
    });
    return careOrderBabyFormErrorTypes;
};
export const handleParamVerifyAndCachePut = async ({ _id, params, careOrderBabyFormForCachePut, careOrderBabyFormInputFieldRefMap, pageRoute, setLoading, setErrorTypes, scrollToInputField, navigateError, }) => {
    setLoading(true);
    const isMockApiMode = (process.env.ENV.TARGET_ENV === 'local' || process.env.ENV.TARGET_ENV === 'dev') &&
        process.env.ENV.TEST_SCENARIO;
    const paramVerifyParams = {
        ...params,
        ...(isMockApiMode && {
            pageRoute,
        }),
    };
    const res = await orderAPI.ParamVerifyV6(paramVerifyParams);
    const badParamsErrorTypes = get(res, 'data.errorTypes', []);
    // #NOTES
    // We implement the validation of the 'tube' field in the frontend and reshape the response.
    // The validation logic of the 'tube' field is to check whether it is empty,
    // if the field is empty then it's invalid, because it means the client did not fill in the field.
    const { tube } = params;
    const isTubeInvalid = tube && tube.length === 0;
    if (isTubeInvalid) {
        badParamsErrorTypes.push('tube');
    }
    const isSuccess = badParamsErrorTypes.length === 0;
    if (isSuccess) {
        await journeyAPI.CachePut({
            _id,
            data: careOrderBabyFormForCachePut,
        });
    }
    else if (badParamsErrorTypes.length > 0) {
        const errorTypes = getCareOrderBabyFormErrorTypes({ badParamsErrorTypes });
        setErrorTypes(errorTypes);
        const firstErrorField = errorTypes[0];
        const fieldRef = careOrderBabyFormInputFieldRefMap[firstErrorField];
        const fieldElement = get(fieldRef, 'current');
        if (fieldElement)
            scrollToInputField({ fieldElement });
    }
    else {
        navigateError(res.errorCode, COMMON_ROUTES.API_ERROR);
    }
    setLoading(false);
    return { isSuccess };
};
